module.exports = __webpack_public_path__ + "img/circlearw.5c87b534.svg";